import colors from '@/constant/colors';

const ICON_SIZE = {
  sm: 16,
  md: 18,
  lg: 24,
  xl: 32,
  xxl: 42,
} as const;

export const ICON_COLOR = {
  white: colors['grayLight-0'],
  black: colors['grayLight-950'],
  gray: colors['grayLight-600'],
  light_gray: colors['grayLight-300'],
  light_blue: colors['info-300'],
  primary: colors.primary,
  light_primary: colors['primary-300'],
  text_blue: colors['info-600'],
  secondary: colors.secondary,
  success: colors['success-250'],
  danger: colors['danger-200'],
  info: colors['info-300'],
} as const;

export default ICON_SIZE;
